import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TaskListService } from "./task-list.service";
import { TaskUpdateService } from "./update.service";
import { TaskCreateService } from "./create.service";
import { TaskByIdService } from "./by-id.service";
import { CreateDraftService } from "./create-draft.service";
import { DraftToCalculationService } from "./draft-to-calculation.service";
import { RemoveDraftService } from "./remove-draft.service";
import { TaskApproveService } from "./approve.service";

@NgModule({
  imports: [CommonModule],
  providers: [
    TaskApproveService,
    TaskListService,
    TaskUpdateService,
    TaskCreateService,
    TaskByIdService,
    DraftToCalculationService,
    RemoveDraftService,
    CreateDraftService,
  ],
})
export class TasksModule {}
